<template>
  <div class="solt_view">
    <div class="f2canvas" v-for="(item, index) in setData" :key="index">
      <canvas
        :id="`boxCanvas_${index}`"
        style="width: 100%; height: auto"
      ></canvas>
      <!-- 图表的lendge -->
      <div class="lendge">
        <div class="first_lengde">
          <img :src="item[0].a==1?$OSSBaseUrl+'yesterday/Ellipse3.png':$OSSBaseUrl+'yesterday/Ellipse1.png'" alt="" class="end_1">
          <div class="first">
            <div class="leng_title">{{item[0].name}}</div>
            <div class="leng_num" :class="item[0].a==1?'skygreen':'orangeprink'">{{item[0].persent}}{{item[0].a==1?'人':''}}</div>
          </div>
          <div class="first">
            <div class="leng_title second_title">新客户占比</div>
            <div class="leng_num" :class="item[0].a==1?'skygreen':'orangeprink'">
              {{item[0].proportion}}%
            </div>
          </div>
        </div>
        <div class="first_lengde">
          <img :src="item[1].a==1?$OSSBaseUrl+'yesterday/Ellipse4.png':$OSSBaseUrl+'yesterday/Ellipse.png'" alt="" class="end_2">
          <div class="second">
            <div class="leng_title">
              <span>{{item[1].name}}</span>
            </div>
            <div class="leng_num" :class="item[1].a==1?'orangeyellow':'orangered'">{{item[1].persent}}{{item[1].a==1?'人':''}}</div>
          </div>
          <div class="second">
            <div class="leng_title">老客户占比</div>
            <div class="leng_num" :class="item[1].a==1?'orangeyellow':'orangered'">
              {{item[1].proportion}}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import F2 from '@antv/f2'
export default {
  props:['setData'],
  data() {
    return {
      chartList: [], //图表数据
    };
  },
  mounted() {
    this.boxCanvas();
  },
  methods: {
    // 单位
    conversion(val){
      if(val>=10000){
        return Math.round(val/10000*100)/100+'w'
      }else{
        return val
      }
    },
    boxCanvas() {
      var data=this.setData
      // var map = {};
      var chart = {};
      var main_title//圈内标题
      var main_num//圈内数字
      // data.map(function (obj) {
      //   map[obj.name] = obj.persent + "人";
      // });
      this.$nextTick(() => {
        for (let i = 0; i < this.setData.length; i++) {
          if(i==0){
            main_title="店铺询盘"
            main_num=data[i][0].sum+'人'
          }else{
            main_title="销售额"
            main_num=this.conversion(data[i][0].sum)
          }
          let style = `width: 120px;height: 120px;display: flex; flex-direction: column; justify-content: center; align-items: center; border-radius: 50%; background-color: ${(data[i][0].persent==0&&data[i][1].persent==0)?'#F4F7FF':''};`
          chart[i] = new F2.Chart({
            id: "boxCanvas_" + i,
            width: 340,
            height: 160,
            // pixelRatio: window.devicePixelRatio,
            padding: [0, 200, 0, 0],
          });

          chart[i].source(JSON.parse(JSON.stringify( data[i])).reverse(), {
            persent: {
              formatter: function formatter(val) {
                return val + "人";
              },
            },
          });
          chart[i].tooltip(false);
          chart[i].legend(false);
          chart[i].coord("polar", {
            transposed: true,
            innerRadius: 0.7,
            radius: 0.85,
          });
          chart[i].axis(false);
          chart[i]
            .interval()
            .position("a*persent")
            .color("name",i==0?["#3160ee","#FF9C00"].reverse():["#FF3984","#FD713E"].reverse())
            .adjust("stack");
          chart[i].guide().html({
            position: ["50%", "50%"],
            html:
              `<div style="${style}">` +
              '<div style="font-size: 3.2vw">' +
                main_num +
              "</div>" +
              '<div style="font-size: 3.2vw">'+main_title+'</div>' +
              "</div>",
          });
          chart[i].render();
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./f2.scss";
</style>